import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface ShareDeviceSidebarProps {
  children?: ReactNode;
}

/**
 * ShareDevice共通のサイドバーコンポーネント
 * シャワールーム画像を表示、オプションで追加のアクションボタンも表示可能
 */
export const ShareDeviceSidebar = ({ children }: ShareDeviceSidebarProps) => {
  const { t } = useTranslation();

  return (
    <aside className="page__aside">
      <div className="page__side">
        <div className="page__side-name">
          <img
            className="page__side-name-img"
            src="/Common_Side_Showerroom.png"
            alt={t('common.altText.showerRoom')}
          />
        </div>
        {children && <div className="page__side-actions">{children}</div>}
      </div>
    </aside>
  );
};
